import { useState, useContext, useEffect } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { AxiosResponse } from "axios";
import {
  FormInputs,
  notificationContextTypes,
  typeApiResponse,
} from "../../../utils/typeDefs";
import { apiUrls } from "../../../utils/apiUrls";
import { Button, Loader, Placeholder } from "rsuite";
import InputText from "../FormAndInputs/inputText.component";
import InputTextArea from "../FormAndInputs/inputTextArea.component";
import InputDatePicker from "../FormAndInputs/inputDatePicker.component";
import InputUploader from "../FormAndInputs/inputUploader.component";
import InputCheckbox from "../FormAndInputs/inputCheckbox.component";
import { getData, convertDate } from "../../../utils/reusables";
import { FileType } from "rsuite/esm/Uploader";
import { postData, putData } from "../../../utils/reusables";
import { typeFormDto, iTypeFormCategories } from "../../../utils/typeDefs";
import { NotificationContext } from "../../../core/context/notificationContextProvider";
import InputTranslationFileUploader from "../FormAndInputs/inputTranslatedFileUploader";
import InputTranslationTitle from "../FormAndInputs/inputTranslationTitle.component";
type formsModalProps = {
  id?: number;
  formCategoryData?: iTypeFormCategories[];
  disableModalBtn?: boolean;
  handleCloseModal: () => void;
  modalType: string | null;
  url: string;
  countryId: number | null;
  setData: (value: typeFormDto[] | null) => void;
  currentRowData?: typeFormDto | null;
  loadData: boolean;
};

const FormsModal = ({
  id,
  formCategoryData,
  disableModalBtn,
  handleCloseModal,
  modalType,
  url,
  countryId,
  setData,
  loadData,
}: formsModalProps) => {
  const [translationContent, setTranslationContent] = useState<
    { blobFile: Blob; name: string }[] | FileType[] | []
  >([]);
  const [contentData, setContentData] = useState<
    { blobFile: Blob }[] | FileType[]
  >([]);
  const [fileRequired, setFileRequired] = useState<boolean>(true);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [checkBoxError, setCheckBoxError] = useState<boolean>(true);
  const [formCategoryInput, setFormCategoryInput] = useState<number[]>([]);
  const [isTranslationLanguage, setIsTranslationLanguage] =
    useState<boolean>(false);
  const [isTranslationFile, setIsTranslationFile] = useState<boolean>(false);

  const [currentRowData, setCurrentRowData] = useState<
    typeFormDto[] | [] | null
  >([]);
  const [showFileData, setShowFileData] = useState<boolean>(false);
  const [showTranslateData, setShowTranslateData] = useState<boolean>(false);

  const hasPrevData = currentRowData && currentRowData.length > 0;

  const { triggerNotification } = useContext(
    NotificationContext
  ) as notificationContextTypes;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInputs>();

  const inputErrorMessage = (message: string) => (
    <span className="text-danger">{message}</span>
  );

  // default form data in edit form

  const handleDefaultData = (data: typeFormDto, url: string) => {
    if (url === "Form" && data.formCategories) {
      setFormCategoryInput(
        data.formCategories.map((item: iTypeFormCategories) => item.id)
      );
    }

    setCurrentRowData([data]);

    return true;
  };

  useEffect(() => {
  }, [isTranslationFile, isTranslationLanguage]);

  useEffect(() => {
    if (id) {
      setShowFileData(true);
      setShowTranslateData(true);

      if (url === "Form") {
        getData(apiUrls.form.getFormById(id)).then((result) => {
          if (result.status === 200) {
            handleDefaultData(result.data, url);
          } else return false;
        });
      } else {
        getData(apiUrls.regulation.getRegulationById(id)).then((result) => {
          if (result.status === 200) {
            handleDefaultData(result.data, url);
          } else return false;
        });
      }
    }
  }, [id, url]);

  // form data submission
  const [submitting, setSubmitting] = useState<boolean>(false);

  useEffect(() => {
    if (modalType === "edit") {
      if (currentRowData && currentRowData[0]?.hasFile) {
        setFileRequired(false);
      }
      if (formCategoryData && formCategoryInput.length !== 0) {
        setCheckBoxError(false);
      }
      
    }
  }, [currentRowData, isTranslationLanguage]);

  const handleData = (
    result: AxiosResponse<{ data: typeFormDto[] } & typeApiResponse>
  ) => {
    handleCloseModal();
    if (result.status === 200 && result.data.succeeded) {
      setData(null);
      result.data.data.forEach((item) => {
        item.entryIntoForce = convertDate(item.entryIntoForce);
        item.lastReview = convertDate(item.lastReview);
        // let asd = new Date(item.entryIntoForce);
        // item.entryIntoForce =convertDate(new Date( new Date(item.entryIntoForce).setDate(asd.getDate() - 1)).toUTCString());
        // asd = new Date(item.lastReview);
        // item.lastReview = convertDate(new Date( new Date(item.lastReview).setDate(asd.getDate() - 1)).toUTCString());
      });
      setData(result.data.data);
      triggerNotification(result.data.succeeded, result.data.message);
    } else {
      triggerNotification(false, "Data update failed");
    }
    setSubmitting(false);
  };

  // multipart data
  const formData = new FormData();

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    setSubmitting(true);

    let key: keyof typeof data;

    for (key in data) {
      if (data[key] !== "" && data[key] !== null) {
        formData.append(key, String(data[key]));
      }
    }

    // modifying data

    if (id) {
      formData.append("Id", String(id));
    }

    // let entryIntoForcedate = new Date(data.EntryIntoForce);
    // entryIntoForcedate.setDate(entryIntoForcedate.getDate()+1);

    formData.set(
      "EntryIntoForce",
      new Date(data.EntryIntoForce).toDateString()
    );
    // let LastReviewDate = new Date(data.LastReview);
    // LastReviewDate.setDate(LastReviewDate.getDate()+1);
    formData.set("LastReview", new Date(data.LastReview).toDateString());

    formData.set("FileTypeName", "pdf");
    formData.set("CountryId", String(countryId));

    if (contentData.length > 0) {
      formData.set("ContentData", contentData[0].blobFile as Blob);
    }

    if (translationContent.length > 0) {
      formData.set(
        "TranslationContentData",
        translationContent[0].blobFile as Blob
      );
    }

    if (formCategoryInput.length > 0) {
      for (let i = 0; i < formCategoryInput.length; i++) {
        formData.append("selectedCategories[]", String(formCategoryInput[i]));
      }
    }
    // data submission

    // if(modalType === "edit" && data.TranslationTitleLanguage){
    //   setIsTranslationLanguage(true);
    // }
  
    if (!hasPrevData && contentData.length === 0) {
      //setFileRequired(true);
      setSubmitting(false);
    } else if (
      modalType !== "edit" &&
      data.TranslationTitleLanguage &&
      translationContent.length === 0
    ) {
      setSubmitting(false);
    } else if (formCategoryData && formCategoryInput.length === 0) {
      setCheckBoxError(true);
      setSubmitting(false);
    } else {
      if (!id) {
        postData(
          url === "Form" ? apiUrls.form.base : apiUrls.regulation.base,
          formData
        ).then((result) => {
          handleData(result);
        });
      } else if (id) {
        postData(
          url === "Form"
            ? apiUrls.form.EditForm
            : apiUrls.regulation.EditRegulation,
          formData
        ).then((result) => {
          handleData(result);
        });
      }
    }
  };

  const renderForm = () => {
    const check = loadData && hasPrevData;
    if (check || !loadData) {
      return true;
    } else return false;
  };

  return (
    <div>
      {!hasPrevData && loadData && (
        <div>
          <Placeholder.Paragraph rows={25} />
          <Loader backdrop content="Loading..." center size="md" vertical />
        </div>
      )}

      {renderForm() && (
        <form className="px-2" onSubmit={handleSubmit(onSubmit)}>
          <InputText
            title="Title"
            inputName="Title"
            errors={errors.Title}
            control={control}
            inputErrorMessage={inputErrorMessage}
            defaultInput={hasPrevData ? currentRowData[0].title : ""}
            rules={{ required: true }}
          />

          <InputText
            title="Language"
            inputName="TitleLanguage"
            errors={errors.TitleLanguage}
            control={control}
            inputErrorMessage={inputErrorMessage}
            defaultInput={hasPrevData ? currentRowData[0].titleLanguage : ""}
            rules={{ required: true }}
          />

          <InputTextArea
            title="Description"
            inputName="Description"
            errors={errors.Description}
            control={control}
            inputErrorMessage={inputErrorMessage}
            defaultInput={hasPrevData ? currentRowData[0].description : ""}
            rules={{ required: true }}
          />

          <InputText
            title="Year"
            inputName="Year"
            errors={errors.Year}
            control={control}
            inputErrorMessage={inputErrorMessage}
            defaultInput={hasPrevData ? String(currentRowData[0].year) : ""}
            rules={{ required: true }}
          />

          <InputDatePicker
            title="Entry Force"
            inputName="EntryIntoForce"
            errors={errors.EntryIntoForce}
            control={control}
            inputErrorMessage={inputErrorMessage}
            defaultInput={
              hasPrevData
                ? new Date(currentRowData[0].entryIntoForce).toISOString()
                : ""
            }
            rules={{ required: true }}
          />

          <InputDatePicker
            title="Last Reviewed"
            inputName="LastReview"
            errors={errors.LastReview}
            control={control}
            inputErrorMessage={inputErrorMessage}
            defaultInput={
              hasPrevData
                ? new Date(currentRowData[0].lastReview).toISOString()
                : ""
            }
            rules={{ required: true }}
          />

          <InputUploader
            title="File"
            data={contentData}
            fileRequired={fileRequired}
            inputErrorMessage={inputErrorMessage}
            showFileData={showFileData}
            setShowFileData={setShowFileData}
            setData={setContentData}
            fileTitle={hasPrevData ? `${currentRowData[0].title}.pdf` : ""}
            setFileRequired={setFileRequired}
            submitting={isSubmitting}
          />

          <InputTranslationTitle
            title="Translation language"
            inputName="TranslationTitleLanguage"
            errors={errors.TranslationTitleLanguage}
            control={control}
            inputErrorMessage={inputErrorMessage}
            defaultInput={
              hasPrevData ? currentRowData[0].translationTitleLanguage : ""
            }
            rules={{ required: isTranslationFile }}
            setIsTranslationLanguage={setIsTranslationLanguage}
            isTranslationFile={isTranslationFile}
            isTransitionLanguage={isTranslationLanguage}
          />

          <InputTranslationFileUploader
            title="Translated File"
            data={translationContent}
            inputErrorMessage={inputErrorMessage}
            showFileData={
              showTranslateData &&
              currentRowData !== null &&
              currentRowData[0].translationTitleLanguage !== "" &&
              currentRowData[0].translationTitleLanguage !== null
            }
            setShowFileData={setShowTranslateData}
            setData={setTranslationContent}
            fileTitle={
              hasPrevData
                ? `${currentRowData[0].title}_${currentRowData[0].translationTitleLanguage}.pdf`
                : ""
            }
            submitting={isSubmitting}
            isTranslationTitle={isTranslationLanguage}
            setIsTranslationFile={setIsTranslationFile}
            isTranslationFile={isTranslationFile}
          />

          {formCategoryData && (
            <div className={"row pb-2 form-input-field"}>
              <div className="col-12 col-md-3 my-auto">
                <p className={"form-label"}>
                  Category:{" "}
                  {isSubmitting &&
                    checkBoxError &&
                    inputErrorMessage("Select one or more categories")}
                </p>
              </div>
              <div className="col-12 col-md-9">
                {formCategoryData
                  ? formCategoryData.map((category: iTypeFormCategories) => (
                      <div
                        key={category?.id}
                        className="form-check form-label ps-0"
                      >
                        <InputCheckbox
                          setCheckBoxError={setCheckBoxError}
                          id={category.id}
                          title={category.title}
                          defaultData={(() => {
                            if (
                              hasPrevData &&
                              currentRowData[0].formCategories
                            ) {
                              let value = false;
                              const arr = currentRowData[0].formCategories;

                              for (let i = 0; i < arr.length; i++) {
                                if (category.id === arr[i].id) {
                                  value = true;
                                  break;
                                } else value = false;
                              }

                              return value;
                            } else return false;
                          })()}
                          setFormCategoryInput={setFormCategoryInput}
                        />
                      </div>
                    ))
                  : ""}
              </div>
            </div>
          )}

          <div className="d-flex">
            <div className={modalType !== "delete" ? "ms-auto" : "d-none"}>
              <Button
                className="me-3 py-2"
                disabled={submitting}
                onClick={() => handleCloseModal()}
                appearance="subtle"
              >
                Cancel
              </Button>
              <Button
                type={"submit"}
                loading={submitting}
                disabled={disableModalBtn}
                className="primary-color me-3 py-2"
                appearance="primary"
                onClick={() => {
                  setIsSubmitting(true);
                }}
              >
                {disableModalBtn && <Loader />} Confirm
              </Button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default FormsModal;
